import { api } from "./client.js";
import type { SortDecision, DecisionsQueryResponse } from "@cas/shared";

export interface DecisionsFilter {
  hours?: number; messageId?: string; sender?: string;
  mode?: string; outcome?: "success" | "error"; limit?: number;
}

export const decisionsApi = {
  query: (f: DecisionsFilter = {}) => {
    const params = new URLSearchParams();
    Object.entries(f).forEach(([k, v]) => { if (v !== undefined && v !== "") params.set(k, String(v)); });
    return api.get<DecisionsQueryResponse>(`manage/decisions?${params}`).then(r => r.decisions);
  },
};
